import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Sparkles, RefreshCw, X } from 'lucide-react';

const ReloadPrompt: React.FC = () => {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered:', r);
    },
    onRegisterError(error) {
      console.error('SW Registration Error:', error);
    },
  });

  const close = () => {
    setNeedRefresh(false);
  };

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 max-w-sm w-full bg-white dark:bg-gray-900 rounded-3xl shadow-2xl border border-emerald-100 dark:border-emerald-950 p-5 animate-fade-in-up transform hover:scale-[1.02] transition-transform duration-300">
      <div className="flex items-start gap-4">
        <div className="p-3 bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-950/30 dark:to-teal-950/30 rounded-2xl text-emerald-600 dark:text-emerald-400">
          <RefreshCw size={24} className="animate-spin-slow" />
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider">
            Nova versão disponível!
          </h4>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-relaxed">
            Uma nova atualização do aplicativo está pronta para ser instalada e melhorar sua experiência.
          </p>

          <div className="mt-4 flex items-center gap-3">
            <button
              onClick={() => updateServiceWorker(true)}
              className="px-4 py-2 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white text-xs font-bold rounded-xl shadow-md shadow-emerald-200 dark:shadow-none transition-all flex items-center gap-2"
            >
              <RefreshCw size={14} />
              Atualizar Agora
            </button>
            <button
              onClick={close}
              className="px-3 py-2 bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 text-xs font-bold rounded-xl transition-colors"
            >
              Fechar
            </button>
          </div>
        </div>

        <button
          onClick={close}
          className="text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors"
          aria-label="Fechar notificação"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default ReloadPrompt;
